import React, { useState } from 'react';
import FormField from '../FormField';
import DataStepLayout from './DataStepLayout';
import ScaleCanvas from './ScaleCanvas';
import StepActions from './StepActions';
import StepShell from './StepShell';
import { cleanFigure, pageImage } from './wizardUtils';

// Scale verification step: either the recognized scale figure or a manual
// percentage / page size definition when no scale was detected.
export default function ScaleStep({ resource, typeLabel, state, onNext, onCancel, loading }) {
  const [scaleText, setScaleText] = useState(resource?.scale?.text || state?.scaleText || '');
  const [percentageScale, setPercentageScale] = useState(state?.percentageScale || '');
  const [pageSize, setPageSize] = useState(state?.pageSize || '');
  const [figure, setFigure] = useState(resource?.scale || null);
  const [isDrawing, setIsDrawing] = useState(false);

  const image = pageImage(resource);
  const title = `${typeLabel || resource?.type || ''} Scale`.trim();

  const handleSubmit = (e) => {
    e.preventDefault();
    onNext(
      figure ? { scaleText, figure: scaleFigureInput(figure) } : { percentageScale, pageSize }
    );
  };

  const preview = !image ? null : figure ? (
    <ScaleCanvas
      figure={figure}
      image={image}
      isDrawing={isDrawing}
      onChangeFigure={(id, updates) => setFigure((prev) => ({ ...prev, ...updates }))}
      onDrawingComplete={() => setIsDrawing(false)}
    />
  ) : (
    <div className="alert alert-info">No scale figure detected.</div>
  );

  return (
    <StepShell>
      <DataStepLayout title={title} preview={preview}>
        <form className="resource-form" onSubmit={handleSubmit}>
          {figure ? (
            <>
              <div className="alert alert-primary" role="alert">
                Verify that the recognized text indicating the scale matches the one in the
                illustration. You can drag the control points to adjust the scale length.
              </div>
              <FormField
                field={{ key: 'scaleText', label: 'Scale Text', type: 'text' }}
                value={scaleText}
                onChange={setScaleText}
              />
              {figure.manualWidth && (
                <div className="alert alert-success">Manual width: {figure.manualWidth}px</div>
              )}
              <StepActions
                submit
                onCancel={onCancel}
                loading={loading}
                className="form-actions"
                leading={
                  <button
                    type="button"
                    className={`btn ${isDrawing ? 'btn-warning' : 'btn-secondary'}`}
                    onClick={() => setIsDrawing(!isDrawing)}
                  >
                    {isDrawing ? 'Cancel Drawing' : 'Draw Scale Length'}
                  </button>
                }
              />
            </>
          ) : (
            <>
              <FormField
                field={{ key: 'percentageScale', label: 'Percentage Scale', type: 'text' }}
                value={percentageScale}
                onChange={setPercentageScale}
              />
              <FormField
                field={{ key: 'pageSize', label: 'Page Size', inputType: 'number' }}
                value={pageSize}
                onChange={setPageSize}
              />
              <StepActions submit onCancel={onCancel} loading={loading} className="form-actions" />
            </>
          )}
        </form>
      </DataStepLayout>
    </StepShell>
  );
}

function scaleFigureInput(figure) {
  return {
    ...cleanFigure(figure),
    contour: figure.contour ? JSON.stringify(figure.contour) : undefined
  };
}
